import React from 'react';
//import { Card, Card.Header, Card.Title, Card.Body } from '@/components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LineChart, Line, AreaChart, Area } from 'recharts';
import { Clock, Target, Award, Calendar, TrendingUp, Users } from 'lucide-react';
import { Card, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';


const EngagementDashboard = () => {

    const { t } = useTranslation();
    const breadcrumbItems: PageBreadcrumbItem[] = [
        {
            label: t('Dashboard'),
            url: '/dashboard/home'
        },
        {
            label: t('Analytics.page_title'),
            url: '/analytics'
        },
        {
            label: t('EngagementDashboard.page_title'),
            active: true
        }
    ];

    // Dati di esempio per l'utilizzo settimanale
    const weeklyUsageData = [
        { day: 'Lun', minutes: 45, sessions: 3 },
        { day: 'Mar', minutes: 60, sessions: 4 },
        { day: 'Mer', minutes: 30, sessions: 2 },
        { day: 'Gio', minutes: 75, sessions: 5 },
        { day: 'Ven', minutes: 45, sessions: 3 },
        { day: 'Sab', minutes: 15, sessions: 1 },
        { day: 'Dom', minutes: 0, sessions: 0 },
    ];

    // Dati di esempio per il completamento attività
    const completionData = [
        { month: 'Set', rate: 65 },
        { month: 'Ott', rate: 72 },
        { month: 'Nov', rate: 78 },
        { month: 'Dic', rate: 85 },
        { month: 'Gen', rate: 82 },
        { month: 'Feb', rate: 88 },
    ];

    // Dati per pattern orari
    const hourlyPatternData = [
        { hour: '8-10', activity: 25 },
        { hour: '10-12', activity: 45 },
        { hour: '12-14', activity: 15 },
        { hour: '14-16', activity: 35 },
        { hour: '16-18', activity: 55 },
        { hour: '18-20', activity: 30 },
        { hour: '20-22', activity: 20 },
    ];

    return (
        <>
            <PageBreadcrumb items={breadcrumbItems} />

            <div className="mt-3">
                {/* Metriche principali */}


                <Row className="p-2 ">
                    <Col md={4}>
                        <Card>
                            <Card.Body className="pt-3">
                                <div className="d-flex flex-column ">

                                    <p className="fs-8">Streak Attuale</p>
                                    <div className="d-flex gap-2">
                                        <p className="fs-7 fw-bold">7 giorni</p>
                                        <Award className="h-8 w-8 text-primary" />
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>

                        <Card className='mt-4'>
                            <Card.Body className="pt-3">
                                <div className="d-flex flex-column">
                                    <p className="fs-8">Tempo Totale</p>
                                    <div className="d-flex  gap-2">
                                        <p className="fs-7 fw-bold ">12.5 ore</p>
                                        <Clock className="h-8 w-8 text-primary" />
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4}>
                        <Card>
                            <Card.Body className="pt-3">
                                <div className="d-flex flex-column">

                                    <p className="fw-medium fs-8">Tasso Completamento</p>
                                    <div className="d-flex  gap-2">
                                        <p className="fs-7 fw-bold">88%</p>
                                        <Target className="h-8 w-8 text-primary" />
                                    </div>

                                </div>
                            </Card.Body>
                        </Card>

                        <Card className='mt-4'>
                            <Card.Body className="pt-3">
                                <div className="d-flex flex-column">

                                    <p className="fw-medium fs-8">Sessioni Settimanali</p>
                                    <div className="d-flex  gap-2">
                                        <p className="fs-7 fw-bold">18</p>
                                        <Calendar className="h-8 w-8 text-primary" />
                                    </div>

                                </div>
                            </Card.Body>
                        </Card>

                    </Col>
                    <Col md={4}>
                        <Card>
                            <Card.Header className="pt-3 ps-3 pb-0">
                                <Card.Title className="d-flex align-items-center gap-2">
                                    <Users className="w-5 h-5" />
                                    Analisi Hot Streak
                                </Card.Title>
                            </Card.Header>
                            <Card.Body className="pb-0">
                                <div className="">
                                    <div className="d-flex align-items-center gap-2 mt-1">
                                        <p className="fw-medium fs-8">Streak più lungo</p>
                                        <p className="fw-bold fs-7">14 giorni</p>
                                    </div>
                                    <div className="d-flex align-items-center gap-2 mt-1">
                                        <p className="fw-medium fs-8">Media streak</p>
                                        <p className="fw-bold fs-7">5 giorni</p>
                                    </div>
                                    <div className="d-flex align-items-center gap-2 mt-1">
                                        <p className="fw-medium fs-8">Streak questo mese</p>
                                        <p className="fw-bold fs-7">3</p>
                                    </div>
                                    <div className="d-flex align-items-center gap-2 mt-1">
                                        <p className="fw-medium fs-8">Giorni attivi</p>
                                        <p className="fw-bold fs-7">85%</p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                </Row>

                <Row className="mt-2 p-2 ">
                    <Col md={4}>
                        {/* Utilizzo Settimanale */}
                        <Card>
                            <Card.Header>
                                <Card.Title className="flex items-center gap-2">
                                    <TrendingUp className="w-5 h-5 me-2" />
                                    Utilizzo Settimanale
                                </Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <BarChart width={400} height={300} data={weeklyUsageData}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="day" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="minutes" fill="#60a5fa" name="Minuti" />
                                    <Bar dataKey="sessions" fill="#93c5fd" name="Sessioni" />
                                </BarChart>
                            </Card.Body>
                        </Card></Col>
                    <Col md={4}>                    {/* Tasso di Completamento */}
                        <Card>
                            <Card.Header>
                                <Card.Title className="flex items-center gap-2">
                                    <Target className="w-5 h-5 me-2" />
                                    Trend Completamento Attività
                                </Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <LineChart width={400} height={300} data={completionData}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="month" />
                                    <YAxis />
                                    <Tooltip />
                                    <Line
                                        type="monotone"
                                        dataKey="rate"
                                        stroke="#2563eb"
                                        strokeWidth={2}
                                        name="Tasso Completamento (%)"
                                    />
                                </LineChart>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={4}>                    {/* Pattern Orari */}
                        <Card>
                            <Card.Header>
                                <Card.Title className="flex items-center gap-2">
                                    <Clock className="w-5 h-5 me-2" />
                                    Pattern di Utilizzo Giornaliero
                                </Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <AreaChart width={400} height={300} data={hourlyPatternData}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="hour" />
                                    <YAxis />
                                    <Tooltip />
                                    <Area
                                        type="monotone"
                                        dataKey="activity"
                                        fill="#93c5fd"
                                        stroke="#2563eb"
                                        name="Livello Attività"
                                    />
                                </AreaChart>
                            </Card.Body>
                        </Card>
                    </Col>

                </Row>

            </div>
        </>
    );
};

export default EngagementDashboard;
